import { render, staticRenderFns } from "./AccountHolderExpenseRepayments.vue?vue&type=template&id=38579ae4&scoped=true"
import script from "./AccountHolderExpenseRepayments.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseRepayments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38579ae4",
  null
  
)

export default component.exports